import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { NotificationService } from '@app/shared/services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SentryInterceptor implements HttpInterceptor {
  constructor(private notification: NotificationService, private translate: TranslateService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).catch((response: any, caught) => {
      if (response instanceof HttpErrorResponse) {
        if (response.status === 400 && !!~req.url.indexOf('v2/operator')) {
          // do not show error if service information invalid
          return Observable.throw(response);
        } else {
          this.notification.handleServiceError(`error ${response.status}:`, {
            message: this.getError(response, req.url)
          });
          return Observable.throw(response);
        }
      }
    });
  }

  getError(response, url) {
    if (response.status == 0) {
      return 'Недоступен сервер ' + url.slice(0, url.lastIndexOf('/'));
    }
    if (response.error.errors) {
      let errorStr = '';
      for (let error in response.error.errors) {
        if (error) {
          errorStr += response.error.errors[error] + ' ';
        }
      }
      console.log('errorstr', errorStr);

      return errorStr;
    }
    if (response.error.code) {
      return `${String(response.error.code).toUpperCase()} ${response.error.message ? response.error.message : ''}`;
    }
    if (response.err) {
      return response.err.message;
    }
    return response.error.message ? response.error.message : response.statusText;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/Intercepters/sentry.interceptor.ts